import React, { memo, useMemo, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Collapse } from '@material-ui/core';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { Add, Map, Visibility, Remove } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button';
import { Link } from 'react-router-dom';
import { formatDate } from 'hooks/Pipe';

function RouteItem(props) {
  const { route, selectedOrdersIds, setInfoWindowData } = props;

  const [collapsed, setCollapsed] = useState(true);

  const [filteredOrders, total] = useMemo(() => {
    let filteredOrders = route.orders.filter((order) => selectedOrdersIds.includes(order.id));
    let total = filteredOrders.reduce((prev, next) => prev + parseFloat(next.total_order), 0);
    return [filteredOrders, total];
  }, [route, selectedOrdersIds]);

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <h4>
            <strong>
              {route.code} {route.description}
            </strong>{' '}
            Pedidos seleccionados: ({filteredOrders.length}) S/ {total.toFixed(2)}
          </h4>
        </div>
        <Button justIcon onClick={() => setCollapsed((collapse) => !collapse)} color="success">
          {collapsed ? <Add /> : <Remove />}
        </Button>
      </div>
      <Collapse in={!collapsed}>
        <div style={{ overflow: 'scroll', maxHeight: '500px' }}>
          <Table style={{ minWidth: '1000px', width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell width={'100px'}></TableCell>
                <TableCell width={'300px'}>Cliente</TableCell>
                <TableCell width={'150px'}>Monto</TableCell>
                <TableCell width={'200px'}>Dirección</TableCell>
                <TableCell width={'150px'}>Fecha</TableCell>
                <TableCell width={'200px'}>Vendedor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredOrders.map((order) => {
                return (
                  <TableRow>
                    <TableCell>
                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        onClick={() => {
                          setInfoWindowData(order);
                        }}
                      >
                        <Map />
                      </Button>
                      <Button justIcon round simple color="primary">
                        <Link to={`/admin/ventas/operaciones/pedidos/#${order.id}`} target="_blank">
                          <Visibility />
                        </Link>
                      </Button>
                    </TableCell>
                    <TableCell>
                      <p>{order.CardCode}</p>
                      <p>{order.CardName}</p>
                    </TableCell>
                    <TableCell>S/ {parseFloat(order.total_order).toFixed(2)}</TableCell>
                    <TableCell>{order.Address2} </TableCell>
                    <TableCell>{formatDate(order.date_order, 'F')}</TableCell>
                    <TableCell>{order.SlpName}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </Collapse>
    </div>
  );
}

function SelectedOrdersCard(props) {
  const { selectedOrders, selectedOrdersIds, routes, setInfoWindowData } = props;
  const totalSelected = useMemo(() => {
    return routes.reduce((prev, nextRoute) => {
      return (
        prev +
        nextRoute.orders
          .filter((order) => selectedOrdersIds.includes(order.id))
          .reduce((prev, nextOrder) => {
            return prev + parseFloat(nextOrder.total_order);
          }, 0)
      );
    }, 0);
  }, [selectedOrdersIds]);

  const filteredRoutes = useMemo(() => {
    return routes.filter((route) =>
      selectedOrders.some((order) => route.id === parseInt(order.base_route_id)),
    );
  }, [routes, selectedOrders]);

  return (
    <CardContainer
      title={`Pedidos seleccionados(${selectedOrders.length}) S/ ${totalSelected.toFixed(2)}`}
      collapse={true}
    >
      {filteredRoutes.map((route) => {
        return (
          <RouteItem
            key={route.id}
            route={route}
            selectedOrdersIds={selectedOrdersIds}
            setInfoWindowData={setInfoWindowData}
          />
        );
      })}
    </CardContainer>
  );
}

export default memo(SelectedOrdersCard);
